module.exports = __webpack_public_path__ + "static/media/kv-zh-Hant.80dcf164.jpg";